import { useT } from "@/lib/i18n";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

const TREEHOUSE = "/story-zinc-fence.jpg";
const BADGE = "/booking-travellers-choice.png?v=3";
const LANDSCAPE = "/lobby-wild-coffee-retreat.jpg";

export default function Story() {
    const { t } = useT();
    return (
        <div data-testid="story-page" className="bg-bone min-h-screen">
            <Navbar />
            <section className="pt-32 lg:pt-40 pb-16 px-6 lg:px-12">
                <div className="max-w-[1100px] mx-auto">
                    <div className="eyebrow mb-4">{t("story.eyebrow")}</div>
                    <h1 className="font-chiller text-5xl lg:text-7xl leading-[1.02] tracking-tight mb-10">
                        <span className="text-terracotta">{t("story.title1")}</span><br />
                        <span className="text-gold">{t("story.title2_em")}</span> <span className="text-forest">{t("story.title2")}</span>
                    </h1>
                </div>
            </section>

            <section className="px-6 lg:px-12 pb-24">
                <div className="max-w-[1100px] mx-auto space-y-24 lg:space-y-32">
                    <div className="aspect-[16/9] overflow-hidden">
                        <img src={LANDSCAPE} alt="The lobby at Wild Coffee Retreat" className="w-full h-full object-cover" />
                    </div>
                    <div className="grid md:grid-cols-12 gap-10">
                        <div className="md:col-span-3 eyebrow pt-2">{t("story.ch1")}</div>
                        <div className="md:col-span-9 text-xl lg:text-2xl leading-relaxed text-ink/85">
                            <p>{t("story.ch1_body")}</p>
                        </div>
                    </div>
                    <div className="grid md:grid-cols-12 gap-10 lg:gap-16 items-center">
                        <div className="md:col-span-6 flex items-center justify-center">
                            <img
                                src={BADGE}
                                alt="Booking.com Traveller's Choice Award winner 2020, 2021 and 2022"
                                data-testid="story-booking-badge"
                                className="w-full max-w-[340px] mx-auto object-contain"
                            />
                        </div>
                        <div className="md:col-span-6">
                            <div className="eyebrow mb-5">{t("story.ch2")}</div>
                            <p className="text-xl lg:text-2xl text-ink/85 leading-relaxed">
                                {t("story.ch2_body")}
                            </p>
                        </div>
                    </div>
                    <div className="grid md:grid-cols-12 gap-10 lg:gap-16 items-center">
                        <div className="md:col-span-6 order-2 md:order-1">
                            <div className="eyebrow mb-5">{t("story.ch3")}</div>
                            <p className="text-xl lg:text-2xl text-ink/85 leading-relaxed">
                                {t("story.ch3_body")}
                            </p>
                        </div>
                        <div className="md:col-span-6 order-1 md:order-2"><img src={TREEHOUSE} alt="Zinc Fence Rest cabin entrance at Wild Coffee Retreat" className="w-full aspect-[4/3] object-cover" /></div>
                    </div>
                    <div className="text-center max-w-3xl mx-auto pt-4" data-testid="story-closing">
                        <p className="text-xl lg:text-2xl leading-relaxed text-ink/85">{t("story.closing")}</p>
                        <p className="font-chiller text-4xl lg:text-5xl text-terracotta mt-8">{t("story.tagline")}</p>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}
